export default function genererAudit() {
  return {
    dateSouhaitee: null,
    datePlanification: null,
    dateRealisation: null,
    dateFacture: null,
    typeOtId: null,
    typeOt: null,
    fournisseurId: null,
    fournisseur: null,
    montantHt: 0,
    description: null,
    taches: [],
    otPatrimoine: {
      otsAuditEnfants: [],
    },
    demandesLogistique: [],
    demandesLogistiqueIds: [],
    bilanIntervention: null,
    agenceId: null,
    villes: [],
    adresse: null,
    codesPostaux: [],
    codeFacture: null,
    auditeurId: null,
    titre: null,
  };
}
